
import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router, Link,
  useLocation
} from "react-router-dom";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../function-components/SecuritySchoolsComponents/IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../function-components/SecuritySchoolsComponents/InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../function-components/SecuritySchoolsComponents/PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../function-components/SecuritySchoolsComponents/CloudSecurity/CloudSecurity";
import "./SecurityLearningFramework.css";
import "../function-components/SecuritySchoolsComponents/TabCard.css";
import LinkTag from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function SecuritySchools(props) {
  const location = useLocation();
  const propsData = location.state ? location.state.tabID : null;
  const [displaySkill, setDisplaySkill] = useState(propsData ? propsData : 'I&Dmanagement');
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <LinkTag
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </LinkTag>
            ,
            <LinkTag
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </LinkTag>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          {/* <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i> */}
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {displaySkill === "I&Dmanagement" ? (
            <a className="menu_title" href="">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {displaySkill === "Infrastructure" ? (
            <a className="menu_title" href="">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {displaySkill === "platformSecurity" ? (
            <a className="menu_title" href="">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {displaySkill === "cloudsecurity" ? (
            <a className="menu_title" href="">
              Cloud Security
            </a>
          ) : (
            ""
          )}
        </Breadcrumbs>
      </div>

      

      <div className="main-container">
      <div className="tabButton-wrapper">
        <a
          className={
            displaySkill === "I&Dmanagement" ? "tabActive" : "tabInactive"
          }
          onClick={() => setDisplaySkill("I&Dmanagement")}
          href="#I&DInitiatives"
        >
          Identity & Access Management
        </a>
        <a
          className={
            displaySkill === "Infrastructure" ? "tabActive" : "tabInactive"
          }
          onClick={() => {
            setDisplaySkill("Infrastructure");
          }}
          href="#InfrastructureSecurity"
        >
          Infrastructure Security
        </a>
        <a
          className={
            displaySkill === "platformSecurity" ? "tabActive" : "tabInactive"
          }
          onClick={() => {
            setDisplaySkill("platformSecurity");
          }}
          href="#platformsecurity"
        >
          Platform Security
        </a>
        <a
          className={
            displaySkill === "cloudsecurity" ? "tabActive" : "tabInactive"
          }
          onClick={() => {
            setDisplaySkill("cloudsecurity");
          }}
          href="#cloudsecurity"
        >
          Cloud Security
        </a>
      </div>
        <div className="boxStyles SSA-wrap">
          {displaySkill === "I&Dmanagement" ? (
            <div className="tabContentWrap">
              <IdentiyAccessManagement />
            </div>
          ) : (
            ""
          )}

          {displaySkill === "Infrastructure" ? (
            <div className="tabContentWrap">
              <InfrastructureSecurity />
            </div>
          ) : (
            ""
          )}

          {displaySkill === "platformSecurity" ? (
            <div className="tabContentWrap">
              <PlatformSecurity />
            </div>
          ) : (
            ""
          )}

          {displaySkill === "cloudsecurity" ? (
            <div className="tabContentWrap">
              <CloudSecurity />
            </div>
          ) : (
            ""
          )}
        </div>
        {/* <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <IdentiyAccessManagement />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box> */}
      </div>
    </>
  );
}

export default SecuritySchools;

